import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import { Divider, Row, Col, Form, Button } from '_zari/core'

import * as LicenciaService from 'services/licencia.service'

import * as FormGroups from './formGroups'

const AdministrativoSection = ({ edicionData }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      cantidadCompanias: edicionData.cantidadCompanias ?? '',
      cantidadSedesxCompanias: edicionData.cantidadSedesxCompanias ?? '',
      cantidadUsuarios: edicionData.cantidadUsuarios ?? '',
      fechaFin: edicionData.fechaFin ?? '',
      flagValidacionActiva: edicionData.flagValidacionActiva ?? false
    }
  }, [edicionData])

  const onSubmit = React.useCallback(
    (data, { setSubmitting }) => {
      LicenciaService.actualizar(data)
        .then(() => {
          __zariContext.snack('success', 'Se ha actualizado la informacion.')
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
        })
        .finally(() => {
          setSubmitting(false)
        })
    },
    [__zariContext]
  )

  return (
    <Formik initialValues={formInitialValues} onSubmit={onSubmit}>
      {({ errors, touched, values, isSubmitting, handleSubmit }) => (
        <Form>
          <Row>
            <Col md={4}>
              <FormGroups.FechaFinFormGroup
                iError={errors.fechaFin}
                iTouched={touched.fechaFin}
                fIsSubmitting={isSubmitting}
              />
            </Col>
            <Col md={4}>
              <FormGroups.FlagValidacionActivaFormGroup
                iValue={values.flagValidacionActiva}
                fIsSubmitting={isSubmitting}
              />
            </Col>
          </Row>
          <Divider title='Valores de configuración' />
          <Row>
            <Col md={4}>
              <FormGroups.CantidadCompaniasFormGroup
                iError={errors.cantidadCompanias}
                iTouched={touched.cantidadCompanias}
                fIsSubmitting={isSubmitting}
              />
            </Col>
            <Col md={4}>
              <FormGroups.CantidadSedesxCompaniasFormGroup
                iError={errors.cantidadSedesxCompania}
                iTouched={touched.cantidadSedesxCompania}
                fIsSubmitting={isSubmitting}
              />
            </Col>
            <Col md={4}>
              <FormGroups.CantidadUsuariosFormGroup
                iError={errors.cantidadUsuarios}
                iTouched={touched.cantidadUsuarios}
                fIsSubmitting={isSubmitting}
              />
            </Col>
          </Row>
          <Row className='mt-2'>
            <Col md={12} className='text-right'>
              <Button disabled={isSubmitting} onClick={handleSubmit}>
                Procesar
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  )
}

export default React.memo(AdministrativoSection)
